import { cloudAuthSession } from "./internal/cloudAuthSession";

export const loginService = {
  async redeemUsernamePassword(args: {
    username: string;
    password: string;
  }) {
    return cloudAuthSession.signInWithUsernamePassword(
      args.username,
      args.password,
    );
  },

  async redeemRefreshToken(refreshToken: string) {
    return cloudAuthSession.redeemRefreshToken(refreshToken);
  },

  async completeNewPasswordChallenge(args: {
    username: string;
    newPassword: string;
    session: string;
  }) {
    return cloudAuthSession.completeNewPasswordChallenge(args);
  },

  async beginForgotPassword(args: { username: string }) {
    return cloudAuthSession.beginForgotPassword(args.username);
  },

  async confirmForgotPassword(args: {
    username: string;
    confirmationCode: string;
    newPassword: string;
  }) {
    return cloudAuthSession.confirmForgotPassword(args);
  },

  beginGoogleOAuth(): string {
    throw new Error("Google OAuth flow is not configured for cloud APIs mode.");
  },

  async redeemGoogleGrantCode(): Promise<never> {
    throw new Error("Google OAuth flow is not configured for cloud APIs mode.");
  },

  getAccessToken(): string | null {
    return cloudAuthSession.getAccessToken();
  },

  getIdToken(): string | null {
    return cloudAuthSession.getIdToken();
  },

  getCachedRefreshToken(): string | null {
    return cloudAuthSession.getCachedRefreshToken();
  },

  getCachedSubject(): string | null {
    return cloudAuthSession.getCachedSubject();
  },

  isAuthenticated(): boolean {
    return cloudAuthSession.isAuthenticated();
  },

  async logout(): Promise<void> {
    await cloudAuthSession.logout();
  },
};
